// Поосле валидации токена сохраняем значение проверки токена

import { sample } from "effector";
import { validateTokenFx } from "./effects";
import { initPage, setInitializing, setQuery } from "./events";
import { checkSearchParams } from "../utils/checkSearchParams";
import { PARAMS } from "./consts";


// Инициализация страницы, проверка query, если хоть одного параметра нет isValid = false
// Считаем что зашли не по ссылке из почты, инициализируем страницу, запрос на проверку
// токена не делаем
sample({
    clock: initPage,
    filter: (params) => {
        const { isValid } = checkSearchParams(params, PARAMS);
        return !isValid;
    },
    target: setInitializing,
})


// Инициализация страницы, проверка query, если все ОК и есть query, делаем запрос на
// валидацию токена, сохраняем query
sample({
    clock: initPage,
    filter: (params) => {
        const { isValid } = checkSearchParams(params, PARAMS);
        return isValid;
    },
    fn: (params) => {
        const { requestParams } = checkSearchParams(params, PARAMS);
        return { uid: requestParams?.uid || '', token: requestParams?.token || '' }
    },
    target: [validateTokenFx, setQuery],
})


// и инициализируем страницу
sample({
    clock: validateTokenFx.finally,
    target: setInitializing,
})
